<script>
import { RouterLink } from 'vue-router'
import useAppRouter from '../../../../../Composables/useAppRouter.ts'
import mixinComponent from '../../../Mixins/mixinComponent'
import buttonMixins from './buttonMixins'

export default {
  mixins: [mixinComponent, buttonMixins],
  props: {
    href: {
      type: [String, RouterLink.props.to],
      required: true,
    },
    external: {
      type: Boolean,
      required: false,
      default: false,
    },
    name: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    target() {
      return this.external ? '_blank' : '_self'
    },
    isRouterLink() {
      return typeof this.href === 'object'
    },
    url() {
      if (this.isRouterLink) {
        return this.generateUrl(this.href)
      }

      return this.href
    },
  },
  setup() {
    const { generateUrl } = useAppRouter()

    return { generateUrl }
  },
}
</script>
<template>
  <a :class="buttonClasses" :href="url" :target="target" :e2e-button="name">
    <label v-if="iconLeft"><i :class="buttonAddIcon" style="cursor: pointer"></i></label>
    {{ $t(label) }}
    <label v-if="iconRight"><i :class="buttonAddIcon" style="cursor: pointer"></i></label>
  </a>
</template>
<style scoped>
a {
  display: flex;
  align-items: center;
}
</style>
